import React from "react";
import CountryPrices from "../CountryPrices";
import Form from "../Form";

const Result = props => {
	const restart = {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		fontSize: "0.75rem",
		fontWeight: "bold",
		color: "rgb(99,221,105)",
		textTransform: "uppercase",
		marginLeft: "2.2rem",
		marginTop: "1rem",
		cursor: "pointer"
	};

	const reverseArrow = {
		maxWidth: "2rem",
		maxHeight: "2rem",
		marginLeft: "0.5rem"
	};

	const secHeadline = {
		margin: "1rem 0"
	};

	const container = {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		height: "100vh"
	};

	const bottomBlock = {
		marginTop: "4rem",
		display: "flex",
		flexDirection: "column",
		alignItems: "center"
	};

	const bottomText = {
		color: "rgb(99,221,105)",
		textTransform: "uppercase",
		fontWeight: "bold"
	};

	const greenArrow = {
		marginTop: "1rem",
		maxWidth: "2rem",
		maxHeight: "6.5rem"
	};

	function handleReset() {
		props.resetSteps();
	}

	return (
		<div>
			<div>
				<div className="resultHeader">
					<div
						className="greenArrow restartArrow"
						onClick={handleReset}
						style={restart}
					>
						<div>Skaičiuoti iš naujo</div>
						<img
							style={reverseArrow}
							alt="reverseArrow"
							src={"/skaiciuokle/img/reverseArrow.png"}
						/>
					</div>
				</div>

				<div style={container}>
					<div className="resultHeadline">JŪSŲ PROJEKTO KAINA</div>
					<div className="resultPrice">€ {props.price}.00</div>
					<span style={secHeadline}>
						Įvertinta pagal 30€/val. įkainį{" "}
					</span>
					<div className="resultTextStyle">
						Tai yra tik preliminarus projekto įvertinimas į
						vertinimą įtraukiant standartines funkcijas,
						šis skaičiuotuvas skirtas tam, kad gautumėt esminį
						supratimą kiek apytiksliai gali kainoti jūsų projektas.
						Kiekvienas projektas yra išskirtinis, paremtas
						unikaliomis idėjomis ir nestandartinėmis funkcijomis.
						Todėl norint gauti tikslesnį įvertinimą ar konsultaciją,
						siūlome kreiptis į profesionalus, kurie galės padėti ir
						patarti projekto vertinimo ir realizavimo klausimais.
						Mediapulsas.lt komanda jau 10 metu kuria įvairaus
						sudėtingumo mobiliąsias aplikacijas ir galės suteikti
						jums kokybiškas paslaugas už sąžiningą rinkos kainą.
					</div>

					<CountryPrices />

					<a className="forMobile" href="#contact-form">
						<div className="alternativeTitle" style={bottomBlock}>
							<div style={bottomText}>
								Nusiųsti užklausą dėl projekto
							</div>
							<img
								alt="greenArrow"
								style={greenArrow}
								className="greenArrow"
								src={"/skaiciuokle/img/greenArrow.png"}
							/>
						</div>
					</a>
					<div style={{ marginBottom: "6rem" }}>
						<Form price={props.price} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Result;
